import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Message, Breadcrumb, Card, Row, Col, Table, Modal, Button, Icon, Badge, Steps, Pagination } from 'antd';
// import PageHeaderLayout from '../../../layouts/PageHeaderLayout';
import styles from './index.less';
import { OrderForm } from '../../../components/';
import { Order, Dashboard, Log } from "../../../models";
import statusEnum from '../statusEnum.json';

const paymentEnum = {
  cash: 'Бэлэн',
  noncash: 'Бэлэн бус',
};

const mapStateToProps = state => ({
  log: state.log.all,
  currentOrder: state.order.current,
  currentLog: state.dashboard.stat,
});

class UBshopOrderDetail extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      current: 1,
      limit: 10,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.orderDetail({ body: { id: this.props.match.params.id } });
    this.props.getAllLogs({
      limit: this.state.limit,
      offset: this.state.current - 1,
      order: this.props.match.params.id,
    });
    // this.props.logs({ body: this.state });
  }

  onChange = async (pagination) => {
    const nextState = {
      current: pagination.current,
    };

    this.setState(nextState);

    await this.props.getAllLogs({
      limit: this.state.limit,
      offset: pagination.current - 1,
      order: this.props.match.params.id,
      ...nextState,
    });
  }

  handleSubmit = async (data) => {
    this.setState({
      visible: false,
    });
    if (this.props.match.params.id) {
      await this.props.orderUpdate({ body: data.formData });
      await this.props.orderDetail({ body: { id: this.props.match.params.id } });
      await this.props.getAllLogs({
        limit: this.state.limit,
        offset: this.state.current - 1,
        order: this.props.match.params.id,
      });
      Message.success('Амжилттай статусыг өөрчиллөө.');
    } else {
      await this.props.orderCreate({ body: data.formData });
      await this.props.orderDetail({ body: { id: this.props.match.params.id } });
      await this.props.getAllLogs({
        limit: this.state.limit,
        offset: this.state.current - 1,
        order: this.props.match.params.id,
      });
      Message.success('Амжилттай статусыг өөрчиллөө.');
      if (!this.props.currentOrder.error) this.props.history.push({ pathname: '/orders' });
    }
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  handleSelectChange = (value) => {
    this.props.update({
      body: {
        id: this.props.match.params.id,
        state: value,
      },
    });
  };

  handleNoteChange = (value) => {
    this.props.update({
      body: {
        id: this.props.match.params.id,
        note: value,
      },
    });
  };

  logColumns = [{
    title: 'Хэрэглэгч',
    key: 'localUser.name',
    width: '140px',
    dataIndex: 'localUser.name',
  }, {
    title: 'Өөрчилсөн төлөв',
    key: 'status',
    width: '180px',
    render: (text, record) => (
      <div>
        <Badge status={statusEnum[record.state].status} text={statusEnum[record.state].text} />
      </div>
    ),
  }, {
    title: 'Огноо',
    key: 'date',
    width: '150px',
    render: (text, record) => <div>{moment(`${record.created_at}`).format('YYYY.MM.DD')} {moment(`${record.created_at}`).format('HH:mm')}</div>,
  }, {
    title: 'Тэмдэглэл',
    key: 'note',
    dataIndex: 'note',
  }]

  render() {
    const {
      currentOrder,
    } = this.props;

    let sum = currentOrder && currentOrder.data && currentOrder.data.carts ? currentOrder.data.carts.reduce((accumilator, element) => {
      let { price } = element.product;
      if (element.product.discount_price) {
        price = element.product.discount_price;
      }
      return accumilator + (price * element.quantity);
    }, 0) : 0;

    const form = {
      schema: {
        title: 'Form',
        type: 'object',
        required: [],
        properties: {
          state: {
            type: 'string',
            label: 'Статус',
            column: 12,
            key: "state",
            options: Object.keys(statusEnum).map(el => ({
              _id: el,
              name: statusEnum[el].text,
            })),
          },
          note: {
            type: 'string',
            column: 12,
            label: 'Тэмдэглэл',
          },
        },
      },
      uiSchema: {
        state: {
          "ui:widget": 'select',
          "ui:placeholder": "Статус оруулна уу",
        },
        note: {
          "ui:widget": 'textarea',
          "ui:placeholder": "Тэмдэглэл оруулна уу",
        },
      },
    };

    const columns = [{
      title: 'Бараа',
      key: 'product.title',
      dataIndex: 'product.title',
      render: (text, record) => <div><Link to={`/products/edit/${record.product.id}`} className={styles.productTitle}>{record.product.title}</Link></div>,
    }, {
      title: 'Бар код',
      key: 'barcode',
      dataIndex: 'product.barcode',
      align: 'center',
    }, {
      title: 'Ширхэг',
      key: 'quantity',
      dataIndex: 'quantity',
      align: 'center',
    }, {
      title: 'Үнэ',
      key: 'product.price',
      dataIndex: 'product.price',
      align: 'right',
      render: (text, record) => <div>{`${record.product.discount_price ? record.product.discount_price.toLocaleString() : record.product.price.toLocaleString()} ₮`}</div>,
    }, {
      title: 'Нийт үнэ',
      key: 'totalprice',
      dataIndex: 'totalprice',
      align: 'right',
      render: (text, record) => <div>{`${record.product.discount_price ? (record.product.discount_price * record.quantity).toLocaleString() : (record.product.price * record.quantity).toLocaleString()} ₮`}</div>,
    }];

    console.log('currentOrder.loading: ', currentOrder);
    return (
      <div>
        <Card
          className={styles.listCard}
          bordered
          loading={currentOrder.isLoading}
          style={{
                marginTop: -24,
                marginLeft: -24,
                marginRight: -24,
                paddingBottom: 24,
                }}
          bodyStyle={{ padding: 0 }}
        >
          <div className={styles.cardInnerBox}>
            <Row span={24}>
              <Breadcrumb style={{ marginBottom: 20 }}>
                <Breadcrumb.Item><Link to="/">Нүүр</Link></Breadcrumb.Item>
                <Breadcrumb.Item><Link to="/orders">Захиалга</Link></Breadcrumb.Item>
                <Breadcrumb.Item>Захиалгын дэлгэрэнгүй</Breadcrumb.Item>
              </Breadcrumb>
            </Row>
            <Row span={24} style={{ marginBottom: 10 }}>
              <Col span={12}>
                <h3 className={styles.orderHeader}>Захиалгын мэдээлэл</h3>
              </Col>
              <Col span={12}>
                <Button onClick={this.showModal} style={{ marginBottom: 15, fontSize: 13, float: 'right' }} size="default" type="primary"><Icon type="edit" /> Статус өөрчлөх</Button>
              </Col>
            </Row>
            <Modal
              title="Захиалгын статус өөрчлөх"
              visible={this.state.visible}
              width={620}
              onCancel={this.handleCancel}
              footer={false}
            >
              <OrderForm
                form={form}
                data={({
                  id: currentOrder.data.id,
                  state: currentOrder.data.state,
                })}
                delete={this.props.orderDelete}
                onSubmit={this.handleSubmit}
              />
            </Modal>
            <Col span={16}>
              <Col span={12} className={styles.orderFields}>Захиалгын дугаар : <span>{currentOrder.data.id}</span></Col>
              <Col span={12} className={styles.orderFields}>Хүлээн авсан огноо : <span>{moment(`${currentOrder.data.created_at}`).format('YYYY-MM-DD HH:mm')}</span></Col>
              <Col span={12} className={styles.orderFields}>Хэрэглэгчийн нэр : <span>{currentOrder.data.name}</span></Col>
              <Col span={12} className={styles.orderFields}>Утасны дугаар : <span>{currentOrder.data.tel}</span></Col>
              <Col span={12} className={styles.orderFields}>Хүргэлтийн хаяг: <span>{currentOrder.data.address}</span></Col>
              <Col span={12} className={styles.orderFields}>Нэмэлт мэдээлэл: <span>{currentOrder.data.desc}</span></Col>
              <Col span={12} className={styles.orderFields}>Төлбөрийн нөхцөл: <span>{paymentEnum[currentOrder.data.payment]}</span></Col>
            </Col>
            <Col span={8}>
              <Col span={24}>
                <Col span={12}>
                  <div className={styles.orderboxRight}>
                    <span className={styles.orderSubhead}>Статус</span>
                    <h3>
                      {
                        statusEnum && currentOrder.data && statusEnum[currentOrder.data.state] &&
                        <Badge status={statusEnum[currentOrder.data.state].status} text={statusEnum[currentOrder.data.state].text} />
                      }
                    </h3>
                  </div>
                </Col>
                <Col span={12}>
                  <div className={styles.orderboxRight}>
                    <span className={styles.orderSubhead}>Нийт</span>
                    <h3 className={styles.orderTotal}>
                      {sum.toLocaleString()} ₮
                    </h3>
                  </div>
                </Col>
              </Col>
            </Col>
          </div>
        </Card>
        <Card
          className={styles.listCard}
          loading={currentOrder.isLoading}
          bordered
          style={{ marginTop: 24 }}
          bodyStyle={{ padding: 0 }}
        >
          <div className={`${styles.cardInnerBox} ${styles.stepBox}`}>
            <Row style={{ paddingTop: 15 }}>
              {
                currentOrder.data.state === "changed" ? (
                  <Steps
                    current={1}
                  >
                    <Steps.Step title="Хүлээн авсан" description={moment(currentOrder.data.created_at).format('YYYY-MM-DD HH:mm')} />
                    <Steps.Step title="Бараа өөрчлөгдсөн" />
                    <Steps.Step title="Хүргэлтэд гарсан" />
                    <Steps.Step title="Хүргэгдсэн" />
                  </Steps>
                ) : (currentOrder.data.state === "cancelled") ? (
                  <Steps
                    status="error"
                    current={1}
                  >
                    <Steps.Step title="Хүлээн авсан" description={moment(currentOrder.data.created_at).format('YYYY-MM-DD HH:mm')} />
                    <Steps.Step title="Цуцлагдсан" description={currentOrder.data.note ? currentOrder.data.note : ''} />
                    <Steps.Step title="Хүргэгдсэн" />
                  </Steps>
                ) : (currentOrder.data.state === "progressing") ? (
                  <Steps
                    current={1}
                  >
                    <Steps.Step title="Хүлээн авсан" description={moment(currentOrder.data.created_at).format('YYYY-MM-DD HH:mm')} />
                    <Steps.Step title="Хүргэлтэд гарсан" description={currentOrder.data.note ? currentOrder.data.note : ''} />
                    <Steps.Step title="Хүргэгдсэн" />
                  </Steps>
                ) : (currentOrder.data.state === "processed") ? (
                  <Steps
                    current={2}
                  >
                    <Steps.Step title="Хүлээн авсан" description={moment(currentOrder.data.created_at).format('YYYY-MM-DD HH:mm')} />
                    <Steps.Step title="Хүргэлтэд гарсан" />
                    <Steps.Step title="Хүргэгдсэн" description={currentOrder.data.note ? currentOrder.data.note : ''} />
                  </Steps>
                ) : (
                  <Steps
                    current={0}
                  >
                    <Steps.Step title="Хүлээн авсан" description={moment(currentOrder.data.created_at).format('YYYY-MM-DD HH:mm')} />
                    <Steps.Step title="Хүргэлтэд гарсан" />
                    <Steps.Step title="Хүргэгдсэн" />
                  </Steps>
                )
              }
            </Row>
          </div>
        </Card>
        <div className={styles.standardList}>
          <Card
            loading={currentOrder.isLoading}
            className={styles.listCard}
            bordered
            style={{ marginTop: 24 }}
            bodyStyle={{ padding: 0 }}
          >
            <div className={styles.cardInnerBox}>
              <Row>
                <Col span={24} style={{ marginBottom: 20 }}>
                  <span className={styles.orderHeading}>Захиалсан бараа</span>
                </Col>
                <Col span={24}>
                  <Table
                    className={styles.dataTable}
                    rowKey={record => record.id}
                    dataSource={this.props.currentOrder.data.carts}
                    columns={columns}
                    pagination={false}
                  />
                </Col>
              </Row>
            </div>
          </Card>
        </div>
        <div className={styles.standardList}>
          <Card
            loading={currentOrder.isLoading}
            className={styles.listCard}
            bordered
            style={{ marginTop: 24 }}
            bodyStyle={{ padding: 0 }}
          >
            <div className={styles.cardInnerBox}>
              <Row>
                <Col span={24} style={{ marginBottom: 20 }}>
                  <span className={styles.orderHeading}>Лог</span>
                </Col>
                <Col span={24}>
                  <Table
                    className={styles.dataTable}
                    rowKey={record => record.id}
                    columns={this.logColumns}
                    dataSource={this.props.log.data}
                    // onChange={pagination => this.onChange(pagination)}
                    pagination={false}
                    // pagination={{ total: this.props.log.total, pageSize: this.state.limit, current: this.state.current }}
                    loading={this.props.log.isLoading}
                  />
                  <div style={{ marginTop: 20, float: 'right' }}>
                    <Pagination
                      defaultCurrent={1}
                      onChange={page => this.onChange({ current: page })}
                      pageSize={this.state.limit}
                      total={this.props.log.total}
                      current={this.state.current}
                      size="small"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </Card>
        </div>
      </div>
    );
  }
}

UBshopOrderDetail.propTypes = {
  currentOrder: PropTypes.object,
  match: PropTypes.object.isRequired,
  orderDelete: PropTypes.func,
  history: PropTypes.object,
  update: PropTypes.func.isRequired,
  orderDetail: PropTypes.func.isRequired,
  orderCreate: PropTypes.func.isRequired,
  orderUpdate: PropTypes.func.isRequired,
  getAllLogs: PropTypes.func.isRequired,
  log: PropTypes.object,
};

UBshopOrderDetail.defaultProps = {
  orderDelete: undefined,
  currentOrder: undefined,
  history: undefined,
  log: {},
};

export default connect(mapStateToProps, {
  formReset: Order.reset,
  orderDetail: Order.get,
  update: Order.update,
  logs: Dashboard.log,
  orderCreate: Order.delete,
  orderUpdate: Order.update,
  getAllLogs: Log.getAllLogs,
})(UBshopOrderDetail);



// WEBPACK FOOTER //
// ./src/containers/Orders/Detail/index.js